<template>
  <div class="compound public-content">
    <div class="breadcrumb">模板主题</div>
    <div class="add-category">
      <div class="keywords">
        <span style="margin:0 5px;">模板主题名称:</span>
        <el-input v-model="vo.themeName"></el-input>
      </div>
      <div>
        <el-button round @click="onSubmit">查询</el-button>
        <el-button round type="primary" @click="$refs.addEdit.show()">添加</el-button>
      </div>
    </div>
    <div class="right-main">
      <div class="data-list">
        <el-table :data="tableData" border>
          <el-table-column label="模板主题名称" prop="themeName"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <span class="color-blue" @click="$refs.addEdit.show(scope.row)">编辑<br></span>
              <span class="color-blue" @click="deleteInfo = scope.row, deleteDialog = true">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" title="确认" :visible.sync="deleteDialog" width="500px">
      <span>确认删除该模板主题?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="deleteTheme()">确 定</el-button>
      </span>
    </el-dialog>
    <addEdit ref="addEdit" @success="onSubmit()"></addEdit>
    <!--    分页-->
    <v-pagination class="v-pagination" :queryInfo="queryInfo" @changePage="changePage"></v-pagination>
  </div>
</template>
<script>
import addEdit from './addEdit/index.vue'
import VPagination from '@/components/Pagination/index'
import { themePage, themeDel } from '@/api/auxx.js'
export default {
  name: 'compound',
  components: {
    VPagination, addEdit
  },
  data () {
    return {
      deleteInfo: {},
      deleteDialog: false,
      vo: {
        themeId: '',
        themeName: ''
      },
      roleDialog: false,
      composeList: [],
      keywords: '',
      queryInfo: {
        pageNum: 1, // 当前显示第几页
        pageSize: 10, // 每一页显示条数
        total: 0
      },
      compoundType: [],
      tableData: []
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.onSubmit()
  },
  methods: {
    deleteTheme () {
      themeDel(this.deleteInfo.themeId)
        .then(res => {
          if (res.data.success) {
            this.$message.success('删除成功')
            this.deleteDialog = false
            this.onSubmit()
          }
        })
    },
    onSubmit () {
      themePage({
        params: { page: this.queryInfo.pageNum - 1, size: this.queryInfo.pageSize },
        vo: this.vo
      })
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.content
            this.queryInfo.total = res.data.data.total
          }
        })
    },
    changePage (val) {
      this.queryInfo = val
      this.onSubmit()
    }
  }
}
</script>
<style scoped lang="less">
.compound {
  .add-category {
    justify-content: space-between;
  }

  .keywords {
    display: flex;
    justify-content: space-around;
    // width: 750px;
    align-items: center;

    .el-input {
      width: 180px;
    }
  }
}
</style>
